export class ReferenceDetails { 
    name!: string;
    phoneNumber!: string;
}